import get from "lodash/get";

export const getVpSaleCode = state => get(state, "partnerData.vpSaleCode", "");
